import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";

const CustomerChangesTable = ({ changes }: { changes: any }) => {
  if (!changes) return null;

  const hasChanges = Object.values(changes).some((c: any) => c.old !== c.new);
  if (!hasChanges) return null;

  return (
    <>
      <Typography variant="h6" sx={{ mt: 2, mb: 0 }} style={{ color: '#fff', background: '#5569ff', padding: '5px' }}>
        Customer Data Changes
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow sx={{ background: "#f5f5f5" }}>
            <TableCell style={{ width: '470px' }}>Field</TableCell>
            <TableCell style={{ width: '250px' }}>Old Value</TableCell>
            <TableCell style={{ width: '250px' }}>New Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.entries(changes).map(([field, change]: any) => {
            if (change.old === change.new) return null;

            return (
              <TableRow key={field}>
                <TableCell>{field}</TableCell>

                <TableCell>
                  <span style={{ color: "red", textDecoration: "line-through" }}>
                    {change.old || "N/A"}
                  </span>
                </TableCell>

                <TableCell>
                  <span style={{ color: "green", fontWeight: 600 }}>
                    {change.new || "N/A"}
                  </span>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>

      </Table>
    </>
  );
};

export default CustomerChangesTable;
